import {
    AnimationBaseController,
    Environment,
    EnvironmentTypeEnum,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';

import * as PIXI from 'pixi.js';
import { AnimationContents } from '../../../AnimationContents';
import { GameModel } from '../../Models/Game/GameModel';

export class OrientationScreenController extends AnimationBaseController {
    $model: GameModel;

    private _graphics: PIXI.Graphics;

    public constructor(@Inject private _options: any) {
        super('OrientationScreenController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.ORIENTATION_SCREEN_JSON,
            libraryName: 'landscape',
        };
    }

    protected onPortrait(): void {
        this.onChangeState();
    }

    protected onLandscape(): void {
        this.onChangeState();
    }

    protected onInitialize(): void {
        this.onChangeState();

        const anim = this.display.children.find(o => o.name === 'animation') as any;
        anim.framerate = Math.floor(anim.framerate / 1.75);
    }

    protected onResize(width: number, height: number, scale: number) {
        if (this._graphics) {
            const w = width / scale;
            const h = height / scale;

            this._graphics.clear();
            this._graphics.beginFill(0x000000, 1);
            this._graphics.drawRect(-w / 2, -h / 2, w, h);
            this._graphics.endFill();
        }
    }

    private onChangeState(): void {
        if (Environment.type !== EnvironmentTypeEnum.pc && !this.isLandscape) {
            if (!this._graphics) {
                this._graphics = new PIXI.Graphics();
                this._graphics.interactive = false;
                this.display.addChildAt(this._graphics, 0);
            }

            this.display.visible = true;
            this.display.interactive = true;

            this.gotoAndPlayByQuery('animation', 0, true, false);
        } else {
            this.display.visible = false;
            this.display.interactive = false;

            this.gotoAndStopByQuery('animation', 0, false);
        }
    }
}
